import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../../vme-common.module';
import { VMEComponentsModule } from '../../../vme-components.module';
import { VmeDirectivesModule } from '../../../vme-directives.module';
import { VmePipesModule } from '../../../vme-pipes.module';
import { SupplierInformationComponent } from './supplier-information.component';
import { TelephonyComponentsModule } from '../../../telephony-components.module';
import { ImpersonateOrganisationModule } from '../../impersonate-organisation/impersonate-organisation.module';
import { SupplierClassificationComponent } from './supplier-classification/supplier-classification.component';

const routes: Routes = [
  { path: '', component: SupplierInformationComponent, data: { title: 'Supplier Information' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SupplierInformationRoutingModule {}

@NgModule({
  imports: [
    SupplierInformationRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TelephonyComponentsModule,
    ImpersonateOrganisationModule,
    SupplierClassificationComponent,
  ],
  declarations: [SupplierInformationComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [SupplierInformationComponent],
})
export class SupplierInformationModule {}
